import React, { useState, useEffect } from "react";
import Axios from './../../../../utils/api/axiosConf';
import { url } from './../../../../utils/api/api';
import { RedNotif, GreenNotif } from "../../../../utils/utils";
import { useParams, useRevalidator, useSearchParams } from "react-router-dom";
import LOADING from "../../../../components/loading/loading";
import { Col, Row } from "antd";
import BUTTON from "./../../../../components/buttons/button";
import { color } from "./../../../../utils/themes/color";
import RADIO from "./../../../../components/radio/radio";
import CHECKBOX from "./../../../../components/checkBox";


export default function HealthStatusAthlete(props) {

    const queryParams = new URLSearchParams(window.location.search);
    const userId = queryParams.get('id');
    const [loading, setLoading] = useState(false);
    const [user, setUser] = useState([]);
    const [data, setData] = useState([]);
    const filters = [{ "name": "سالم", "value": true }, { "name": "مبتلا به بیماری", "value": false }];
    const [selected, setSelected] = useState([]);
    const [filter, setFilter] = useState(true);
    const [updator, setUpdator] = useState(1)

    useEffect(() => {
        Axios.get(`${url}sicknesses/v1/sickness-list`)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    var x = [];
                    for (const iterator of response.data) {
                        x.push({
                            name: iterator.title,
                            value: iterator._id
                        })
                    }
                    setData(x)
                }
                else {
                    RedNotif(response.message)
                    setLoading(false)
                }
            })
            .catch((error) => {
                RedNotif("سرور در حال حاضر قادر به پاسخگویی نمی باشد !")
            });

    }, [updator])

    useEffect(() => {
        setLoading(true)
        Axios.get(`${url}users/athlete-get-health-status/${userId}`)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    if (response.data.sicknesses != null && response.data.sicknesses != undefined && response.data.sicknesses != "") {
                        var x = [];
                        for (const iterator of response.data.sicknesses) {
                            x.push(iterator._id)
                        }
                        setSelected(x)
                    }

                    if (response.data.healthStatus != "healthy") {
                       setFilter(false)
                    } else {
                        setFilter(true)
                    }
            
                    setLoading(false)

                }
                else {
                    RedNotif(response.message)
                    setLoading(false)
                }
            })
            .catch((error) => {
                console.log("er", error)
                RedNotif("سرور در حال حاضر قادر به پاسخگویی نمی باشد !")
            });

    }, [updator])


    const updateHealthStatus = () => {

        if (filter) {
            Axios.patch(`${url}users/athlete-health-status/${userId}`, { "healthStatus": "healthy" })
                .then(async (response) => {
                    if (response.status === 200 || response.status === 201) {
                        setUpdator(updator + 1)
                        props.pager(5)
                        GreenNotif(response.message);
                        setLoading(false);
                    } else {
                        RedNotif(response.message);
                        setLoading(false);
                    }
                })
                .catch((error) => {
                    RedNotif("سرور قادر به پاسخ گویی نمی باشد")
                    console.log("error", error)
                    setLoading(false)
                });
        } else {
            var x = {
                healthStatus: "sick",
                sicknesses: selected

            }


            Axios.patch(`${url}users/athlete-health-status/${userId}`, x)
                .then(async (response) => {
                    if (response.status === 200 || response.status === 201) {
                        setUpdator(updator + 1)
                        props.pager(5)
                        GreenNotif(response.message);
                        setLoading(false);
 
                    } else {
                        RedNotif(response.message);
                        setLoading(false);
                    }
                })
                .catch((error) => {
                    RedNotif("سرور قادر به پاسخ گویی نمی باشد")
                    console.log("error", error)
                    setLoading(false)
                });
        }

        setLoading(true);

    }



    switch (loading) {
        case true: return (
            <div style={{ marginTop: "80px" }}>
                <LOADING type={"lg"} />
            </div>
        )
        case false: return (
            <>
                <Row style={{ marginBottom: '18px' }}>
                    <Col xxl={24} xl={24} lg={24} md={24} sm={24}>
                        <p>وضعیت سلامتی خود را مشخص نمایید:</p>
                    </Col>
                </Row>

                <Row style={{ marginRight: '8px', marginBottom: "48px" }}>
                    <Col xxl={24} xl={24} lg={24} md={24} sm={24}>
                        <div style={{ display: 'flex', padding: "0 12px", marginRight: '8px' }}>
                            <p style={{ color: color.primary }}></p>
                        </div>
                        <RADIO click={(e) => { setFilter(e) }} items={filters} defaultValue={filter} />

                    </Col>
                </Row>

                {
                    filter
                        ? <></>
                        :
                        <>
                            <Row style={{ marginRight: '8px' }}>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
                                    <div style={{ display: 'flex', padding: "0 12px", marginRight: '8px' }}>
                                        <p>نوع بیماری:</p>
                                        <p style={{ color: color.mandatoryColor }}>*</p>                                    </div>
                                    <br />

                                    <CHECKBOX
                                        click={(e) => {
                                            var x = user;
                                            x.push(e)
                                            setUser(e)
                                        }}
                                        items={data}
                                        selectedItems={selected}
                                        check={(e) => { setSelected(e) }

                                        }
                                    />
                                </Col>
                            </Row>

                        </>

                }




                <Row style={{ marginTop: '42px' }} gutter={20}>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} />
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6}>
                        <BUTTON event={(e) => updateHealthStatus()} text="ثبت و بعدی" type={"submit"} loading={loading} />
                    </Col>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6}>
                        <BUTTON event={(e) =>  props.pager(5)} text="رد کردن" type={"cancel"} />

                    </Col>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} />
                </Row>
            </>
        )
    }


}